/* eslint-disable jsx-a11y/label-has-associated-control */

import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import 'react-datepicker/dist/react-datepicker.css';
import { Form } from 'semantic-ui-react';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
const InfograpicModal = ({
  t,
  recordID,
  title,
  setTitle,
  titleEn,
  setTitleEn,
  // content,
  // setContent,
  // contentEn,
  // setContentEn,
  publicationDate,
  setPublicationDate,
  link,
  keywords,
  setKeywords,
  setLink,
  onUpdate,
  setGridModalupdate,
  gridModalupdate,
  doc,
  setDoc,
  imageSrc,
  showPreview,
  onChange,
  fileInputRef
}) => {
  const todayDate = new Date();

  return (
    <>
      <>
        {gridModalupdate ? (
          <>
            {/* <div
              className={`flex justify-center items-center overflow-x-hidden h-full w-full ${isActive ? 'top-0 right-0  ' : 'top-0 left-0 '} opacity-100 fixed inset-40 z-50 bg-black bg-opacity-50 outline-none focus:outline-none`}
            >
              <div className="border-0 rounded-lg shadow-lg bg-green-50 flex-col pt-20 outline-none focus:outline-none relative   w-4/5 flex justify-center max-h-[450px] overflow-y-auto p-5 z-50 my-6 mx-auto max-w-3xl">
                <div className="flex justify-center rounded-t ">
                  <h3 className="text-xl pt-20 justify-center text-center text-customgreen font-semibold">
                    {t('update')} {t('cms_infographic')}
                  </h3>
                </div>
                <div className="relative p-1 flex-auto">
                  <form className="  rounded px-8  pb-3 w-full">
                    <div className="row justify-center">
                      <div className="col-lg-6 flex flex-col items-start justify-start">
                        <label className="block text-customgreen text-sm font-bold my-2">{t('cms_title')}</label>
                        <input
                          name="title"
                          maxLength={1000}
                          value={title}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="text"
                          onChange={(e) => setTitle(e.target.value)}
                          placeholder={t('cms_title')}
                        />
                        <label className="block text-customgreen text-sm font-bold my-2">{t('cms_content')}</label>
                        <textarea
                          name="content"
                          value={content}
                          onChange={(e) => setContent(e.target.value)}
                          className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="text"
                          placeholder={t('cms_content')}
                        />
                      </div>
                      <div className="col-lg-6 flex flex-col items-start justify-start">
                        <label className="block text-customgreen text-sm font-bold my-2">{t('Title En')}</label>
                        <input
                          name="titlen"
                          maxLength={1000}
                          value={titleEn}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="text"
                          onChange={(e) => setTitleEn(e.target.value)}
                          placeholder={t('Title En')}
                        />
                        <label className="block text-customgreen text-sm font-bold my-2">{t('Content En')}</label>
                        <textarea
                          name="contentAr"
                          value={contentEn}
                          onChange={(e) => setContentEn(e.target.value)}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="text"
                          placeholder={t('Content En')}
                        />
                      </div>
                    </div>

                    <div className="row justify-center">
                      <div className="col-lg-6 flex flex-col items-start justify-start">
                        <label className="block text-customgreen text-sm font-bold my-2">{t('cms_keywords')}</label>
                        <input
                          type="text"
                          name="keywords"
                          value={keywords}
                          onChange={(e) => setKeywords(e.target.value)}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          placeholder={t('cms_keywords')}
                        />
                        <label className="block text-customgreen text-sm font-bold my-2">
                          {t('cms_publicationDate')}
                        </label>
                        <input
                          name="publicationDate"
                          value={publicationDate}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          onChange={(e) => setPublicationDate(e.target.value)}
                          placeholder={t('cms_publicationDate')}
                        />
                      </div>
                      <div className="col-lg-6 flex flex-col items-start justify-start">
                        <label className="block text-customgreen text-sm font-bold my-2">{t('cms_link')}</label>
                        <input
                          name="link"
                          value={link}
                          className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          type="text"
                          onChange={(e) => setLink(e.target.value)}
                          placeholder={t('cms_link')}
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div className="flex items-center justify-center space-x-2 p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                    type="button"
                    onClick={() => onUpdate(recordID)}
                  >
                    {t('Submit')}
                  </button>
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    {t('Close')}
                  </button>
                </div>
              </div>
            </div> */}
            <MDBModal tabIndex="-1" show={gridModalupdate} setShow={setGridModalupdate}>
              <MDBModalDialog className="flex justify-center items-center">
                <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                  <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                    <MDBModalHeader className="flex justify-center items-center">
                      <MDBModalTitle className="text-customgreen font-semibold">
                        {t('update')} {t('cms_infographic')}
                      </MDBModalTitle>
                      {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className="container-fluid bd-example-row">
                        <div className="row" style={{ marginBottom: '10px' }}>
                          <div className="col-md-6 col-example">
                            <label className="mx-auto text-customgreen">{t('cms_title')}: </label>
                            <input
                              maxLength={1000}
                              name="title"
                              value={title}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              type="text"
                              onChange={(e) => setTitle(e.target.value)}
                              placeholder={t('cms_title')}
                            />
                          </div>

                          <div className="col-md-6 col-example">
                            <label className="mx-auto text-customgreen">{t('Title En')}: </label>
                            <input
                              maxLength={1000}
                              name="titleEn"
                              value={titleEn}
                              className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              type="text"
                              onChange={(e) => setTitleEn(e.target.value)}
                              placeholder={t('Title')}
                            />
                          </div>
                          {/* <div className="col-md-6 col-example ">
                            <label className="mx-auto text-customgreen">{ t('cms_content') }: </label>
                            <textarea
                              name="content"
                              value={ content }
                              className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                              onChange={ (e) => setContent(e.target.value) }
                              placeholder={ t('Content') }
                            />
                          </div> */}
                          {/* <div className="col-md-6 col-example">
                            <label className="mx-auto text-customgreen">{ t('Content En') }: </label>
                            <textarea
                              name="contentEn"
                              value={ contentEn }
                              className=" border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                              onChange={ (e) => setContentEn(e.target.value) }
                              placeholder={ t('Content') }
                            />
                          </div> */}
                          <div className="col-md-6  col-example">
                            <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                            <input
                              name="keywords"
                              value={keywords}
                              onChange={(e) => setKeywords(e.target.value)}
                              className=" border w-full p-2 border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen focus:ring-2 "
                              placeholder={t('cms_keywords')}
                            />
                          </div>
                          <div className="col-md-6  col-example">
                            <label className="mx-auto text-customgreen">{t('cms_link')} : </label>
                            <input
                              name="link"
                              value={link}
                              className="border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen"
                              type="text"
                              onChange={(e) => setLink(e.target.value)}
                              placeholder={t('cms_link')}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="flex flex-col col-md-6 col-example">
                            <DatePickerLayout
                              label={'cms_publicationDate'}
                              selectedDate={publicationDate}
                              keyValue={'to'}
                              dateTo={publicationDate}
                              setDateTo={setPublicationDate}
                              maxDate={todayDate}
                            />
                          </div>
                          <div className="col-md-6 col-example">
                            <Form.Field>
                              <label className="mx-auto text-customgreen">{t('cms_image')}</label>
                              <input
                                ref={fileInputRef}
                                onChange={(showPreview, onChange)}
                                type="file"
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              />
                            </Form.Field>
                          </div>
                          <div className="flex justify-center mt-2  ">
                            <img
                              style={{
                                height: '120px',
                                width: '150px',
                              }}
                              src={doc ? `data:image/jpeg;base64,${doc}` : imageSrc}
                              className="card-img-top"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </MDBModalBody>
                    <MDBModalFooter className="flex justify-center">
                      <button
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                        onClick={() => onUpdate(recordID)}
                      >
                        {t('Submit')}
                      </button>
                      <button
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                        onClick={() => setGridModalupdate(false)}
                      >
                        {t('close')}
                      </button>
                    </MDBModalFooter>
                  </Form>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </>
        ) : null}
      </>
    </>
  );
};

export default InfograpicModal;
